// Maps the live player record (from useMePlayerProfile → GET
// /users/me/players/:id) into the shape the FamilyContactForm's player card
// needs. Keeps the modal driven by real selected-player data rather than the
// (mocked) family-list player field.
import type { FamilyContactFormPlayer } from './FamilyContactForm'

export const toFamilyContactPlayer = (
  player:
    | {
        id?: string
        name_first?: string | null
        name_last?: string | null
        full_name?: string | null
        image?: { full_path?: string | null } | null
        birth_date?: string | null
        height?: string | number | null
        weight?: string | number | null
      }
    | null
    | undefined
): FamilyContactFormPlayer | null => {
  if (!player?.id) {
    return null
  }
  const fullName =
    player.full_name ||
    `${player.name_first ?? ''} ${player.name_last ?? ''}`.trim() ||
    null
  return {
    id: player.id,
    name_full: fullName,
    image: player.image ?? null,
    birth_date: player.birth_date ?? null,
    height: player.height ?? null,
    weight: player.weight ?? null,
  }
}
